const id_master_payment_method = {
    "": "metode pembayaran",
    name: "nama metode pembayaran",
    time: "lama (hari)",
    add: "tambah metode pembayaran",
    edit: "ubah metode pembayaran",

    error: {
        create: "Gagal membuat metode pembayaran.",
        delete: "Gagal menghapus metode pembayaran.",
        edit: "Gagal mengubah metode pembayaran.",
        time: "Lama (hari) tidak boleh kosong.",
    },

    success: {
        create: "Berhasil membuat metode pembayaran.",
        delete: "Berhasil menghapus metode pembayaran.",
        edit: "Berhasil mengubah metode pembayaran.",
    }
}

export default id_master_payment_method;